export default {"src":"/_next/static/media/rewards.5ee2c7d6.svg","height":35,"width":40,"blurWidth":0,"blurHeight":0};